import { MaintenanceWindowSelectorWebComponent } from './component/MaintenanceWindowSelectorWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_SELECTOR } from '../../webcomponents.constants';

export { MaintenanceWindowSelectorWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOW_SELECTOR, MaintenanceWindowSelectorWebComponent);
